export const getErrorCriteriaIndexes = (errors, errorType, index) => {
  return errors.filter(error => error.type === errorType && error.index === index).map(error => error.criterionIndex)
}
